import { POST } from "../../index";

export const getCarRepairList = (param) => POST("/v1/carRepair/getCarRepairList", param);
export const insertCarRepair = (param) => POST("/v1/carRepair/insertCarRepair", param);
export const getRepair = (param) => POST("/v1/carRepair/getRepair", param);
